import { environment } from '@environment/environments';

export const CONTACT_REQUEST_URL = `${environment.baseUrl}/pahdp-notification/v1/contact-requests`;
